// import React, { useState, useEffect } from "react";
// import axios from "axios";

// const TestimonialSection = () => {
//   const [testimonialData, setTestimonialData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Fetch Data
//   useEffect(() => {
//     const fetchTestimonialData = async () => {
//       try {
//         const res = await axios.get("https://all-in-one-youtube-cc51e2f64b53.herokuapp.com/api/testimonial-section");
//         setTestimonialData(res.data.data);
//       } catch (err) {
//         console.error("Failed to fetch testimonial data", err);
//         setError("Failed to load section.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchTestimonialData();
//   }, []);

//   // Helper to render star icons
//   const renderStars = (rating) => {
//     return Array.from({ length: rating }).map((_, i) => (
//       <li key={i}>
//         <i className="icofont-ui-rate-blank" />
//       </li>
//     ));
//   };

//   if (loading) return <div className="text-center py-5">Loading Testimonials...</div>;
//   if (error || !testimonialData) return null;

//   return (
//     <>
//       <div
//         className="testimonial-section padding-top padding-bottom"
//         style={{ backgroundImage: `url(${testimonialData.backgroundImage})` }}
//       >
//         <div className="container">
//           <div className="section-header">
//             <p>{testimonialData.subtitle}</p>
//             <h2>{testimonialData.mainTitle}</h2>
//           </div>
//           <div className="section-wrapper">
//             <div className="testimonial-slider overflow-hidden swiper-container-initialized swiper-container-horizontal">
//               <div className="swiper-wrapper">
//                 {/* --- Map Dynamic Testimonials --- */}
//                 {testimonialData.testimonials.map((item, index) => (
//                   <div
//                     key={item.id || index}
//                     className="swiper-slide"
//                     data-swiper-slide-index={index}
//                   >
//                     <div className="testimonial-item">
//                       <div className="testimonial-inner">
//                         <div className="testimonial-head">
//                           <div className="testi-top">
//                             <div className="testimonial-thumb">
//                               <img
//                                 src={item.image}
//                                 alt={item.name}
//                               />
//                             </div>
//                             <div className="name-des">
//                               <h5>{item.name}</h5>
//                               <p>{item.role}</p>
//                             </div>
//                           </div>
//                           <a href="team-single.html">
//                             <img
//                               src={item.logo}
//                               alt="Client Logo"
//                             />
//                           </a>
//                         </div>
//                         <div className="testimonial-body">
//                           <p>
//                             "{item.content}"
//                           </p>
//                         </div>
//                         <div className="testimonial-footer">
//                           <ul>
//                             {renderStars(item.rating || 5)}
//                           </ul>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//               <span
//                 className="swiper-notification"
//                 aria-live="assertive"
//                 aria-atomic="true"
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default TestimonialSection;
import React, { useState, useEffect } from "react";
import axios from "axios";

// Import Swiper React components and required modules
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";

const TestimonialSection = () => {
  const [testimonialData, setTestimonialData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch Data
  useEffect(() => {
    const fetchTestimonialData = async () => {
      try {
        const res = await axios.get("https://all-in-one-youtube-cc51e2f64b53.herokuapp.com/api/testimonial-section");
        setTestimonialData(res.data.data);
      } catch (err) {
        console.error("Failed to fetch testimonial data", err);
        setError("Failed to load section.");
      } finally {
        setLoading(false);
      }
    };
    fetchTestimonialData();
  }, []);

  // Helper to render star icons
  const renderStars = (rating) => {
    return Array.from({ length: rating }).map((_, i) => (
      <li key={i}>
        <i className="icofont-ui-rate-blank" />
      </li>
    ));
  };

  if (loading) return <div className="text-center py-5">Loading Testimonials...</div>;
  if (error || !testimonialData) return null;

  return (
    <div
      className="testimonial-section padding-top padding-bottom"
      style={{ backgroundImage: `url(${testimonialData.backgroundImage})` }}
    >
      <div className="container">
        <div className="section-header text-center">
          <p>{testimonialData.subtitle}</p>
          <h2>{testimonialData.mainTitle}</h2>
        </div>
        
        <div className="section-wrapper">
          <div className="testimonial-slider overflow-hidden">
            
            {/* --- Swiper Component --- */}
            <Swiper
              modules={[Autoplay, Pagination]}
              spaceBetween={30}
              slidesPerView={1}
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              pagination={{ clickable: true }}
              breakpoints={{
                // Responsive breakpoints
                768: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 2, // Adjust to 3 if you add more testimonials
                },
              }}
            >
              {testimonialData.testimonials.map((item) => (
                <SwiperSlide key={item.id}>
                  <div className="testimonial-item">
                    <div className="testimonial-inner">
                      <div className="testimonial-head">
                        <div className="testi-top">
                          <div className="testimonial-thumb">
                            <img src={item.image} alt={item.name} />
                          </div>
                          <div className="name-des">
                            <h5>{item.name}</h5>
                            <p>{item.role}</p>
                          </div>
                        </div>
                        <a>
                          <img src={item.logo} alt="Client Logo" />
                        </a>
                      </div>
                      <div className="testimonial-body">
                        <p>"{item.content}"</p>
                      </div>
                      <div className="testimonial-footer">
                        <ul>{renderStars(item.rating || 5)}</ul>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSection;